import { modelOptions, post, prop } from "@typegoose/typegoose";
import { z } from "zod";
import { getZodSchemaFromClass, validate } from "../../../zod-decorator/index.js";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import { SoilLayerFieldsWithDefaults, SoilLayerSchemaTypes } from "../../types/soilLayer.d.js";
import { DtoValidatorTypes } from "../../validatableClass.js";

const SCHEMA_KEY = "SoilLayer" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<SoilLayer>>(...addSchemaKeyHook(SCHEMA_KEY))
export class SoilLayer extends SchemaBase<SoilLayer, SoilLayerFieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;

    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: z.number() })
    @prop({ type: () => Number, required: true })
    public sandPercentage!: number;

    @validate({ zodValidator: z.number() })
    @prop({ type: () => Number, required: true })
    public clayPercentage!: number;

    /**
     * in meters
     * @type {number}
     */
    @validate({ zodValidator: z.number() })
    @prop({ type: () => Number, required: true })
    public depth!: number;

    @validate({ zodValidator: z.number().optional() })
    @prop({ type: () => Number, required: false })
    public recommendedCapacity?: number;

    @validate({ zodValidator: z.number().optional() })
    @prop({ type: () => Number, required: false })
    public lastMoistureReading?: number;

    @validate({ zodValidator: z.coerce.date().optional() })
    @prop({ type: () => Date, required: false })
    public lastMoistureReadingDate?: Date;

    @validate({ zodValidator: z.number().nullable().optional() })
    @prop({ type: () => Number, required: false })
    public userCapacity?: number | null;

    static dtoValidators: DtoValidatorTypes<SoilLayerSchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<SoilLayer, SoilLayerFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

SoilLayer.dtoValidators = getZodSchemaFromClass(SoilLayer) as unknown as DtoValidatorTypes<SoilLayerSchemaTypes>;
